import styled, { css } from 'styled-components';
import { LoyaltyBadgeWrapper } from '@/app/common/components/LoyaltyBadge/styled.ts';
import { BADGE_SLOTS } from './types';

const priceAddonsStyles = css`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  margin-top: 8px;
  margin-bottom: 8px;

  @media (max-width: 1190px) {
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    flex-wrap: wrap;
  }

  @media (max-width: 767px) {
    justify-content: flex-start;
    margin-top: 12px;
    margin-bottom: 12px;
    width: 100%;
  }
`;

const dealHighlightsStyles = css`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;

  @media (max-width: 1190px) {
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    flex-wrap: wrap;
  }

  @media (max-width: 767px) {
    justify-content: flex-start;
    margin-top: 12px;
    margin-bottom: 0;
    width: 100%;
  }
`;

const galleryOverlayStyles = css`
  position: absolute;
  top: 16px;
  left: 16px;
  right: 16px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`;

const cardGalleryOverlayStyles = css`
  ${galleryOverlayStyles};

  && > * {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
  }
`;

const hotelHeaderStyles = css`
  display: contents;

  ${LoyaltyBadgeWrapper} {
    margin-left: 0;
    margin-bottom: 0;

    > div {
      height: 28px;
    }
  }
`;

const SLOT_STYLES: Record<BADGE_SLOTS, ReturnType<typeof css>> = {
  [BADGE_SLOTS.DEAL_HIGHLIGHTS]: dealHighlightsStyles,
  [BADGE_SLOTS.PRICE_ADDONS]: priceAddonsStyles,
  [BADGE_SLOTS.GALLERY_OVERLAY]: galleryOverlayStyles,
  [BADGE_SLOTS.GALLERY_OVERLAY_OLD]: cardGalleryOverlayStyles,
  [BADGE_SLOTS.HOTEL_HEADER]: hotelHeaderStyles,
};

export const SlotContainer = styled.div<{ $slot: BADGE_SLOTS }>`
  ${({ $slot }) => SLOT_STYLES[$slot]}
`;
